import { render, staticRenderFns } from "./my404.vue?vue&type=template&id=bc870a62&scoped=true"
import script from "./my404.vue?vue&type=script&lang=js"
export * from "./my404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc870a62",
  null
  
)

export default component.exports